var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('aboutBTC',{attrs:{"id":"aboutus1"}}),_vm._v(" "),_c('terms',{attrs:{"id":"statement1"}}),_vm._v(" "),_c('privacy-policy',{attrs:{"id":"privacypolicy1"}}),_vm._v(" "),_c('contact-us',{attrs:{"id":"contact1"}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4be11568","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 